import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const ImageIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M8.88889 8.11111C8.45933 8.11111 8.11111 8.45933 8.11111 8.88889C8.11111 9.31844 8.45933 9.66667 8.88889 9.66667C9.31844 9.66667 9.66667 9.31844 9.66667 8.88889C9.66667 8.45933 9.31844 8.11111 8.88889 8.11111ZM6.11111 8.88889C6.11111 7.35476 7.35476 6.11111 8.88889 6.11111C10.423 6.11111 11.6667 7.35476 11.6667 8.88889C11.6667 10.423 10.423 11.6667 8.88889 11.6667C7.35476 11.6667 6.11111 10.423 6.11111 8.88889Z"
      fill="currentColor"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M3 6.5C3 4.567 4.567 3 6.5 3H17.5C19.433 3 21 4.567 21 6.5V17.5C21 19.433 19.433 21 17.5 21H6.5C4.567 21 3 19.433 3 17.5V6.5ZM6.5 5C5.67157 5 5 5.67157 5 6.5V17.5C5 18.3284 5.67157 19 6.5 19H6.53756L12.9823 11.4179C14.3065 9.86009 16.6783 9.76409 18.124 11.2098L19 12.0858V6.5C19 5.67157 18.3284 5 17.5 5H6.5ZM19 14.9142L16.7098 12.624C16.0902 12.0044 15.0737 12.0456 14.5062 12.7132L9.16244 19H17.5C18.3284 19 19 18.3284 19 17.5V14.9142Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

ImageIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(ImageIcon);
